export default __webpack_public_path__ + "static/media/error_icon.6f966b79.svg";